import { render } from "./OpeningTimePerDay.vue?vue&type=template&id=0cbd9170&ts=true"
import script from "./OpeningTimePerDay.vue?vue&type=script&lang=ts"
export * from "./OpeningTimePerDay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__